// eslint-disable-next-line import/prefer-default-export
export const SUBSCRIBE_FOR_INTERNET_WITH_SLYDEPAY_URL = `https://tizeti.com/williams_rd/ghanapaymentapi/api.php`;
export const INITIALIZE_TELLER_PAYMENT_API_URL = `http://tizeti.com/williams_rd/ghanapaymentapi/api.php`;
